import { CSS } from '@grupoboticario/flora-react'

export const filterBadgeCss: CSS = {
  backgroundColor: '$light-light',
  width: '$6',
  height: '$6',
  margin: '0 10px',
  borderRadius: '$large'
}

export const filterBadgeTextCss: CSS = {
  color: '$nonInteractiveEmphasis'
}

export const drawerHeaderCss: CSS = {
  borderBottom: '1px solid $nonInteractiveAuxiliar'
}

export const categoryBoxCss: CSS = {
  marginTop: '$5'
}

export const filterBoxCss: CSS = {
  marginTop: '$3'
}

export const dateRangeHalfCss: CSS = {
  width: 'calc(50% - 4px)'
}

export const filterFooterCss: CSS = {
  marginTop: '$6'
}
